<!-- header -->
<app-breadcrumb [styleBreadcrumb]="'page-heading'" [title]="'EVENTS'" [breadcrumb]="breadcrumb"
    [isStringLiteral]="stringLiteralBreadcrumb" [count]="total" icon="fa-inbox-in">
</app-breadcrumb>
<!-- body -->
<div class="content-background">
    <div class="row">
        <div class="col-sm-12">
            <div class="inputWithIcon inputWithIcon-search float-right d-flex">
                <app-advanced-mode id="eventGridAdvancedSwitch" [storageKey]="'events-list'"
                    (collapsibleToggle)="enableAdvanced=$event">
                </app-advanced-mode>
                <input #search kendoTextBox class="ml-4 button-search" title="{{ 'SEARCH-EVENTS' | translate }}"
                    placeholder="{{ 'SEARCH-EVENTS' | translate }}" (keyup)="searchFieldChange(search.value)" />
                <i class="fa fa-search fa-lg fa-fw fa-search-icon"></i>
            </div>
        </div>
    </div>
    <!-- events data grid -->
    <div class="mt-3">
        <kendo-grid #grid [data]="gridView"
            [pageable]="total > state.take ? { buttonCount: 5, pageSizes: pageSizes} : false" [pageSize]="state.take"
            [skip]="state.skip" [loading]="loading" [sort]="state.sort" [filter]="state.filter" [sortable]="true"
            [filterable]="enableAdvanced" [columnMenu]="enableAdvanced" [resizable]="true"
            [reorderable]="enableAdvanced" (dataStateChange)="dataStateChange($event)">
            <kendo-grid-messages noRecords="{{ 'NO-EVENTS' | translate }}">
            </kendo-grid-messages>
            <ng-template kendoGridToolbarTemplate [position]="'top'" *ngIf="enableAdvanced && !isUpdate">
                <button kendoButton (click)="filterDialogOpened=true">{{ 'SAVE-FILTER' | translate }}</button>
            </ng-template>
            <ng-template kendoGridToolbarTemplate [position]="'top'" *ngIf="enableAdvanced && isUpdate">
                <button kendoButton (click)="filterDialogOpened=true">{{ 'UPDATE-FILTER' | translate }}</button>
            </ng-template>
            <kendo-grid-column field="icon" [width]="3" class="font-weight-bold emphasizedLabel text-center"
                [filterable]="false" [sortable]="false" [columnMenu]="false" title="">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <i title="{{getEventIconTitle(dataItem)}}" *ngIf="dataItem.eventType"
                        [className]="dataItem.eventTypeIcon"></i>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="eventType" title="{{ 'EVENT-TYPE' | translate }}" [width]="20"
                [columnMenu]="false">
                <ng-template kendoGridCellTemplate let-dataItem>
                    {{dataItem.eventTypeText}}
                </ng-template>
                <ng-template kendoGridFilterCellTemplate let-filter>
                    <app-dropdown-filter [filter]="filter" [data]="eventTypes" filterField="eventType" textField="text"
                        selectDefaultText="{{ 'SELECT-EVENT' | translate }}" valueField="value">
                    </app-dropdown-filter>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="encounterType" title="{{ 'ENCOUNTER-TYPE' | translate }}" [width]="20"
                [columnMenu]="false" [hidden]="true">
                <ng-template kendoGridCellTemplate let-dataItem>
                    {{dataItem.encounterTypeText}}
                </ng-template>
                <ng-template kendoGridFilterCellTemplate let-filter>
                    <app-dropdown-filter [filter]="filter" [data]="encounterTypes" filterField="encounterType"
                        selectDefaultText="{{ 'SELECT-ENCOUNTER' | translate }}" textField="text" valueField="value">
                    </app-dropdown-filter>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="member" title="{{ 'MEMBER' | translate:patientLabel }}" [width]="15">
                <ng-template kendoGridCellTemplate let-dataItem>
                    {{dataItem.memberName}}
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="details" title="{{ 'DETAILS' | translate }}" [width]="25"></kendo-grid-column>
            <kendo-grid-column field="facility" title="{{ 'FACILITY' | translate }}" [width]="20"></kendo-grid-column>
            <kendo-grid-column field="eventDateTime" title="{{ 'EVENT-DATE' | translate }}" [width]="17" filter="date"
                format="{0:d}">
                <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
                    <kendo-grid-date-filter-cell [column]="column" [filter]="filter" operator="gte">
                        <kendo-filter-after-eq-operator></kendo-filter-after-eq-operator>
                        <kendo-filter-after-operator></kendo-filter-after-operator>
                        <kendo-filter-before-eq-operator></kendo-filter-before-eq-operator>
                        <kendo-filter-before-operator></kendo-filter-before-operator>
                    </kendo-grid-date-filter-cell>
                </ng-template>
                <ng-template kendoGridCellTemplate let-dataItem>
                    <div *ngIf="dataItem.eventDateTime!==null">
                        {{ intl.formatDate(intl.parseDate(dataItem.eventDateTime), "g") }}
                    </div>
                </ng-template>
            </kendo-grid-column>
        </kendo-grid>
    </div>
</div>

<!-- save filter dialog -->
<app-save-filter [dialogOpened]="filterDialogOpened" [filterCategory]="'Event'" [filterState]="state"
    (cancelling)="filterDialogOpened=false;" [filter]="filterElement">
</app-save-filter>